export default __webpack_public_path__ + "static/media/775.ddf17349.png";